<template>
   <div class="app-inner" id="enCourseAssign">
         <div class="public-btn-small flex align-cen posta">
            <div class="public-btn-small-plan"  style="margin-left:0" @click="$util.reback('/teacheManage/enCourse')">
            返回
            </div>
            </div>
             <div class="p-tit-c">
            <div class="businessList-filter">
            <div class="businessList-filter-list flex align-cen">
            <div class="fl-le flex align-cen">
          <div class="label">学员姓名：</div>
          <div class="el-select1">
            <el-input placeholder="请输入学员姓名" v-model="search" clearable> </el-input>
          </div>
         </div>
             <div class="fl-rt flex align-cen">
          <div class="label">学员手机号码：</div>
          <div class="el-select1">
          <el-input placeholder="请输入学员手机号码" v-model="search1" clearable> </el-input>
          </div>
         </div>
      </div>
           <div class="businessList-filter-list flex align-cen">
              <div class="fl-le flex align-cen">
          <div class="label">学员组分类：</div>
                     <el-select
                        v-model="value"
                        clearable
                        placeholder="请选择"
                        @change="classSelect"
                    >
                        <el-option
                        v-for="item in studentClass"
                          :key="item.id"
                        :label="item.name"
                        :value="item.id"
                        >
            </el-option>
          </el-select>
        </div>
      </div>
        <div class="businessList-filter-list flex align-cen">
              <div class="fl-le flex align-cen">
          <div class="label">学员关联仿真系统：</div>
                     <el-select
                        v-model="value1"
                        clearable
                        placeholder="请选择"
                        @change="classSelect"
                    >
                        <el-option
                        v-for="item in option"
                          :key="item.id"
                        :label="item.appName"
                        :value="item.id"
                        >
            </el-option>
          </el-select>
        </div>
      </div>
       <div class="businessList-filter-list flex align-cen public-btn-small">
        <div class="public-btn-small-primary" @click="classSelect">
        搜索
        </div>
      <div class="public-btn-small-plan" @click="assignStu">
          指派学员
        </div>
        <div class="public-btn-small-text" @click="reset">
        重置筛选条件  
        </div>
      </div>
            </div>
             </div>
          <div class="businessList-container">
          <div class="businessList-container-table">
                   <el-table
                ref="multipleTable"
                :data="list"
                tooltip-effect="dark"
                style="width: 100%"
                id='mytable'
                :header-cell-style="{background:'#eeeeee',color:'#666',paddingBottom:'10px'}"
                >
                     <el-table-column prop="loginName" label="手机/账号" align="center">
                 </el-table-column>
                  <el-table-column prop="" label="学员头像" align="center">
                    <template slot-scope="scope">
                       <img :src="scope.row.avatar ? scope.row.avatar : require('../../../assets/images/nullimg.png')" alt="" style="display: block;width:60px;height:60px;margin:0 auto;border-radius:50%"> 
                    </template>
                 </el-table-column>
                  <el-table-column prop="" label="学员分类" align="center">
                     <template slot-scope="scope">
                      <div class="flex align-cen" style="justify-content:center" v-if="scope.row.traineeClassifyRelationList.length">
                      <div v-for="(item,index) in scope.row.traineeClassifyRelationList"  class="tagbq">
                            {{item.classifyName}}
                        </div>
                        </div>
                        <div v-else>-</div>
                     </template>
                  </el-table-column>
                  <el-table-column prop="userName" label="昵称/姓名" align="center"> 
                 </el-table-column>
                  <el-table-column label="关联仿真系统" align="center">
                     <template slot-scope="scope">
                      <p style="color:red;cursor:pointer" @click="openAppList(scope.row)">{{scope.row.allocateNum}}个</p>
                  </template>
                 </el-table-column>
                  <el-table-column
                    fixed="right"
                    label="操作"
                    align="center"
                    width="150"          
                    >
                     <template slot-scope="scope">
                      <el-button type="text" style="color:red" @click="deletS(scope.row)">取消</el-button> 
                     </template>
                   </el-table-column>
             </el-table>
                <paginaTion :total="totalCount" @sendStatus="emitFun"></paginaTion>
          </div>
          </div>
                       <!-- 已分配系统弹窗 -->
           <el-dialog
  title="已分配系统"
  :visible.sync="centerDialogVisible"
  width="50%"
  :append-to-body="true"
  center
  v-if="centerDialogVisible"
  >
     <div class="businessList-container-table">
    <el-table
          ref="multipleTable1"
          :data="systesList"
          tooltip-effect="dark"
          style="width: 100%"
          id='mytable'
          :header-cell-style="{background:'#fff',color:'#90909e',paddingBottom:'20px'}"
        >
         <el-table-column prop="appName" label="系统名称" align="center" width="300">
          </el-table-column>
           <el-table-column  label="登录次数" align="center">
            <template slot-scope="scope">
                <p>{{scope.row.loginNum || '-'}}</p>
            </template>
          </el-table-column>
            <el-table-column  label="最后学习时间" align="center">
            <template slot-scope="scope">
                <p >{{scope.row.lastStudyTime || '-'}}</p>
            </template>
          </el-table-column>
          <el-table-column  label="考试次数" align="center">
            <template slot-scope="scope">
                <p >{{scope.row.examNum || '-'}}</p>
            </template>
          </el-table-column>
          <el-table-column  label="考试合格次数" align="center">
            <template slot-scope="scope">
                <p >{{scope.row.passNum || '-'}}</p>
            </template>
          </el-table-column>
    </el-table>
   </div>
           </el-dialog>
           <!-- 指派学员 -->
 <el-dialog
  title="指派学员"
  :visible.sync="centerDialogVisible1"
  width="35%"
  :append-to-body="true"
  :show-close="false"
  center
  v-if="centerDialogVisible1"
  >
            <div class="settings-box">
                <div class="settings-box-tips flex align-cen">
                    <div class="red-div"></div>
                    <p class="red-div-p">指派学员</p>
                </div>
                        <div class="settings-box-check form-check">
                        <el-checkbox v-model="checked">
                            选择分组 <span>(已选{{dynamicTags1.length || '0'}}个考生组)</span>
                        </el-checkbox>
                        <div v-if="checked">
                          <div class="tagsinput">
                            <div class="classItem">
                                <el-tag
                                    :key="tag.id"
                                    v-for="tag in dynamicTags1"
                                    closable
                                    :disable-transitions="false"
                                    @close="handleClose(tag,1)">
                                    {{tag.name || tag.allocateName}}
                                    </el-tag>
                                </div>
                        </div>
                        <div class="select-stu" @click="openStu(1)">选择分组</div>
                        </div>
                      </div>
                            <div class="settings-box-check form-check">
                        <el-checkbox v-model="checked1">
                            选择学员 <span>(已选{{dynamicTags2.length || '0'}}个考生)</span>
                        </el-checkbox>
                        <div v-if="checked1">
                          <div class="tagsinput">
                            <div class="classItem">
                                <el-tag
                                    :key="tag.id"
                                    v-for="tag in dynamicTags2"
                                    closable
                                    :disable-transitions="false"
                                    @close="handleClose(tag,2,tag)">
                                    {{tag.userName || tag.allocateName}}
                                    </el-tag>
                                </div>
                        </div>
                        <div class="select-stu" @click="openStu(2)">选择学员</div>
                        </div>
                      </div>
                  <div class="businessList-filter-list flex align-cen public-btn-small" style="justify-content:center;padding-left:0px">
                  <div class="public-btn-small-plan" style="margin-right:30px" @click="centerDialogVisible1 = false">
                取消
                </div>
                  <el-button type="primary" class="public-btn-small-primary public-btn-small-load"
                    @click.stop="setStu"
                    :loading="loading"
                    >
                      确定
                    </el-button>
                    </div>
          </div>
 </el-dialog>
       <el-dialog
  title="选择分组"
  :visible.sync="centerDialogVisible2"
  width="40%"
  :append-to-body="true"
  center
  custom-class="publicDialogClass"
  v-if="centerDialogVisible2"
  >
    <div class="forminfo">
          <el-alert
            title="当勾选分组后，其分组下学员都可以考试"
            type="warning"
            :closable="false"
             show-icon
            >
        </el-alert>
         <div class="form-check">
        <el-checkbox-group v-model="studentCheck">
            <el-checkbox v-for="(item,index) in studentClass"   :label="item.id" >
               <div class="jstree-node flex align-cen">
                <i class="jstree-icon"></i>
                <span class="jstree-name">{{item.name}}</span>
                </div> 
             </el-checkbox>
            </el-checkbox-group >
        </div>
        <div class="authbtn flex align-cen">
        <el-button plain @click="centerDialogVisible2 = false"> 取消</el-button>
              <el-button type="primary" @click.stop="putCheck(1)">选择</el-button>
    </div>
    </div>
      </el-dialog>
             <!-- 打开学生列表 -->
      <el-dialog
  title="选择考生"
  :visible.sync="centerDialogVisible3"
  width="60%"
  :append-to-body="true"
  center
  custom-class="publicDialogClass"
  v-if="centerDialogVisible3"
  >
  <div class="forminfo">
        <studentTemplate
          :authType='1'
    ref="studentTemplate"
     @sendStatus="stclassSelect"
        ></studentTemplate>
         <div class="authbtn flex align-cen">
        <el-button plain @click="centerDialogVisible3 = false"> 取消</el-button>
         <el-button type="primary" @click.stop="putCheck(2)">选择</el-button>
    </div>
  </div>
      </el-dialog>
    </div>
</template>
<script>
import {getAllStudentClass,getTeacherAppList,getStudentList1,removeMycourse,courseAllocateList,addCourse} from "@/api/enterprise/index"  //学员分类、仿真系统列表、取消指派学员、课程详情
import paginaTion from "@/components/paginaTion/index.vue"; //分页组件
import  studentTemplate from "@/weteacheManage/member/studentList/index.vue"; //将题目分类页面作为组件使用
export default {
     components:{
      paginaTion,
      studentTemplate
    },
    data() {
        return {
          loading:false,
          studentClass:[],
            studentCheck:[],
          checked:false,
          checked1:false,
          dynamicTags1:[],
          dynamicTags2:[],
          centerDialogVisible1:false,
          systesList:[],
          centerDialogVisible:false,
          centerDialogVisible2:false,
          centerDialogVisible3:false,
            option:[],
            businessInfo:{},
            search:'',
            search1:'',
            studentClass:[],
            value:'',
            value1:'',
            list:[],
            totalCount:0,
            currentPage: 1, //初始页
            PageSize: 10, //每页的数据
        }
    },
    created() {
     this.businessInfo = this.$locaStorage.setAge().get('businessInfo')   
     this.getclass()
     this.getSystem()
     this.getList()
    },
    methods: {
      // 确定指派
      setStu(){
         if(this.checked || this.checked1){
                if(this.checked){
               if(!this.dynamicTags1.length) return this.$util.Notifi('请选择指定组','error','fa-exclamation-circle')
                }else if(this.checked1){
             if(!this.dynamicTags2.length) return this.$util.Notifi('请选择指定考生','error','fa-exclamation-circle')
            }
              }else{
                return this.$util.Notifi('请选择指定组或指定考生考试','error','fa-exclamation-circle')
              }
              if(!this.checked){
                this.dynamicTags1 = []
              }
              if(!this.checked1){
                this.dynamicTags2 = []
              }
                let mergedArray = [...this.dynamicTags1.map(item => ({allocateId:(item.businessId || item.id == 1 ? item.id : item.allocateId), type: 1})), ...this.dynamicTags2.map(item => ({allocateId:item.businessId ? item.id : item.allocateId, type: 2}))]; 
                 let params = { 
                  allocateList:mergedArray,
                  businessId:this.businessInfo.id,
                  id:this.$route.query.id
                 };
                 let method = "put"
                this.loading = true
               addCourse(params,method)
              .then(res => {
                  if(res.code == 0){
                  this.loading = false
                  this.centerDialogVisible1 = false,
                  this.getList()
                  }else{
                    this.loading = false
                  this.$util.Notifi(res.msg,'error','fa-exclamation-circle');
                  }
              })
              .catch(err => {
                  this.loading = false
              })
      },
         stclassSelect(val,val1){
            // console.log(val)
            this.dynamicTags2 = val
        },
        // 选择学生组
        putCheck(type){
            if(type == 1){
                if(!this.studentCheck.length) return this.$util.Notifi('请先勾选','error','fa-exclamation-circle')
                
                    this.dynamicTags1 = this.studentClass.filter(item => this.studentCheck.some(ele=>ele===item.id))
                this.centerDialogVisible2 = false
            }
            if(type == 2){
                if(!this.dynamicTags2.length) this.$util.Notifi('请先勾选','error','fa-exclamation-circle')
                this.centerDialogVisible3 = false
            }
        },
        getclass1(type){
            this.studentCheck = []
            getAllStudentClass({businessId:this.businessInfo.id,name:''})
            .then(res =>{
                this.studentClass = res.data
                if(this.dynamicTags1.length){
                   for (let key in this.dynamicTags1) {
                    this.studentCheck.push((this.dynamicTags1[key].businessId ? this.dynamicTags1[key].id : this.dynamicTags1[key].allocateId)) 
                   }
                    
                }

            })
        },
           // 打开学生组
        openStu(type){
           if(type == 1){
             this.centerDialogVisible2 = true
            this.getclass1(1)
           }
           if(type == 2){
            this.centerDialogVisible3 = true
            this.$nextTick(function () {   
                 this.$refs.studentTemplate.steditfun(this.dynamicTags2)    
             })
           }
        },
         // 标签移除
        handleClose(tag,type){
           this['dynamicTags' + type].splice(this['dynamicTags' + type].indexOf(tag), 1);
            if(type == 1) {
                this.studentCheck = this.studentCheck.filter(item => this.dynamicTags1.some(ele=>ele.id===item))
            }
        },
      // 指派学员 
      assignStu(){
        this.studetChFun(1)
        this.studetChFun(2)
        this.centerDialogVisible1 = true
      },
          studetChFun(type){
        courseAllocateList({id:this.$route.query.id,type:type})
        .then(res =>{
            // console.log(res.data)
           this['dynamicTags' + type] = res.data || []
           if(type == 1 && this.dynamicTags1.length) this.checked = true
            if(type == 2 && this.dynamicTags2.length) this.checked1= true

        })
        },
        // 筛选
        classSelect(){
            this.currentPage = 1
            this.getList()
        },
        // 重置
        reset(){
            this.search = ''
            this.search1 = ''
            this.value = ''
            this.value1 = ''
            this.currentPage=1
            this.getList()
        },
                // 子组件触发
      emitFun(val,val1){
        if(val1 == "PageSize") this.PageSize = val
       if(val1 == "currentPage") this.currentPage = val
       this.getList()
      },
             // 获取分页列表
      getList(){
         let params = {
                userName:this.search,
                loginName:this.search1,
                classifyId:this.value,
                appId:this.value1,
                classifyId:this.value,
                 current: this.currentPage,
                size:this.PageSize,
                businessId:this.businessInfo.id,
                courseId:this.$route.query.id
            }
            getStudentList1(params)
            .then(res =>{
              this.list = res.data.records
             this.totalCount = res.data.total;
            })
      },
       // 打开关联仿真系统
        openAppList(data){
        this.centerDialogVisible = true
        this.getSystem1(data)
        },
        getSystem1(data){
             getTeacherAppList({id:data.businessId,accountId:data.id},'enterprise')
            .then(res =>{
               this.systesList = res.data
            })
        },
          getclass(){
            this.studentCheck = []
            getAllStudentClass({businessId:this.businessInfo.id,name:''})
            .then(res =>{
                this.studentClass = res.data
            })
        },
          getSystem(){
             getTeacherAppList({id:this.businessInfo.id,accountId:''},'enterprise')
            .then(res =>{
               this.option = res.data
            })
        },
           // 删除跳转企业管理后台deletS
        deletS(data){
            let params = {
              businessId:this.businessInfo.id,
              courseId:this.$route.query.id,
              accountId:data.id
            }
           this.$confirm('确定要取消该学员吗？', '取消学员', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
              }).then(() => {
                  removeMycourse(params)
                  .then(res =>{
                    if(res.code == 0){
                      this.$util.Notifi('取消成功','success','fa-check')
                   this.getList()
                    }else{
                      this.$util.Notifi(res.msg,'error','fa-exclamation-circle');
                    }
                  })
              }).catch(() => {          
              });
        },
    },
}
</script>
<style lang="scss" scoped>
#enCourseAssign{
  margin-bottom: 60px;
}
.tagbq{
    background-color: #ecf5ff;
    border-color: #d9ecff;
    color: #409eff;
    display: inline-block;
    height: 32px;
    padding: 0 10px;
    line-height: 30px;
    font-size: 12px;
    color: #409eff;
    border-width: 1px;
    border-style: solid;
    border-radius: 4px;
    box-sizing: border-box;
    white-space: nowrap;
    margin-right: 10px;
}
         .settings-box-check{
            padding-left: 25px;
            padding-top: 10px;
            .tagsinput{
            width: 80% !important;
            min-height: 56px;
            max-height: unset;
            height: 56px;
            padding: 0px 12px 0 12px;
            background-color: #ffffff;
            border-radius: 4px!important;
            border: solid 1px #e6e6e6!important;
            overflow-y: auto;
            line-height: 27px;
            margin: 10px 25px;
            .classItem{
                padding-top: 12px;
                .el-tag{
                    margin-right: 10px;
                }
            }
            }
            .select-stu{
                margin-left: 25px;
                background-color: #36aafd;
                color: white;
                border: 1px solid #36aafd;
                padding: 7px 0px;
                border-radius: 4px!important;
                width: 122px;
                cursor: pointer;
                text-align: center;
            }
         }
        .settings-box{
            margin-bottom: 48px;
            .settings-box-tips{
                margin-bottom: 20px;
                .red-div{
                    width: 4px;
                    height: 15px;
                    background-color: #409eff;
                    margin-right: 5px;
                }
                .red-div-p{
                 font-size: 16px;
                letter-spacing: 0px;
                color: #333333!important;
                height: unset;
                font-weight: 700;
                }
            }
        }
          ::v-deep{
       .is-checked{

    .el-radio__label,.el-checkbox__label{
    position: relative;
    padding-left: 5px;
    color: #333;
    font-weight: 400;
    }
.el-checkbox__label{
    padding-left: 10px;
}
   } 
   .el-checkbox__label{
    span{
        font-size: 14px;
        color: #999;
    }
   }
   .el-checkbox-group{
    .el-checkbox{
        margin-bottom: 20px;
        display: block;
    }
}
     .forminfo{
        .form-check{
            padding: 20px 50px;
        }
        .el-checkbox-group{
            .el-checkbox{
                display: flex !important;
                align-items: center !important; 
            }
        }
        .jstree-icon{
             display: block;
            width: 24px;
            height: 24px;
            
            background: url('../../../assets/images/tree-default.svg') no-repeat 0 0;
        }
        .jstree-name{
            padding-left: 5px;
        }
    }
  }
</style>